<template>
  <span>{{ text }}</span>
</template>
<script>
import {getAction} from '@/api/manage'

export default {
  name: 'SDict',
  props: {
    value: [String, Number],
    code: String
  },
  data() {
    return {
      text: '',
      url: '/home/selectNameByValue'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selectNameByValue()
      },
    }
  },
  created() {
  },
  methods: {
    selectNameByValue() {
      const _this = this
      getAction(_this.url, {code: _this.code, value: _this.value}).then(res => {
        if (res.success) {
          _this.text = res.result;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
